import { PickerCategory, PickerMode, PickerNavKind, PickerOption } from './types';

const BACK_OPTION: PickerOption = { kind: PickerNavKind.Back };
const LOADING_OPTION: PickerOption = { kind: PickerNavKind.Loading };
const CATEGORY_OPTIONS: PickerOption[] = [
  { kind: PickerNavKind.Category, category: PickerCategory.Users },
  { kind: PickerNavKind.Category, category: PickerCategory.Groups },
];

interface BuildPickerOptionsParams {
  mode: PickerMode;
  enableGroups: boolean;
  rows: PickerOption[];
  loading: boolean;
  pending: boolean;
  query: string;
  emptyUsersText: string;
}

export const buildPickerOptions = ({
  mode,
  enableGroups,
  rows,
  loading,
  pending,
  query,
  emptyUsersText,
}: BuildPickerOptionsParams): PickerOption[] => {
  if (mode === 'root') {
    return CATEGORY_OPTIONS;
  }

  const isGroups = mode === PickerCategory.Groups;
  const emptyMessage = query.trim()
    ? `No ${isGroups ? 'groups' : 'users'} match your search`
    : isGroups
      ? 'No groups available'
      : emptyUsersText;

  // `options` is never empty, so MUI's own loadingText/noOptionsText never render — hence our own rows.
  return [
    ...(enableGroups ? [BACK_OPTION] : []),
    ...rows,
    ...(rows.length > 0
      ? []
      : [loading || pending ? LOADING_OPTION : { kind: PickerNavKind.Empty as const, message: emptyMessage }]),
  ];
};
